import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { ListModule } from 'app/shared/components/list/list.module';
import { ModalModule } from 'app/shared/components/modal/modal.module';
import { PaginationModule } from 'app/shared/components/pagination/pagination.module';
import { ToolbarModule } from 'app/shared/components/toolbar/toolbar.module';
import { TooltipModule } from 'app/shared/components/tooltip/tooltip.module';
import { BlockModalDragModule } from 'app/shared/directives/block-modal-drag/block-modal-drag.module';
import { ButtonModule } from '../../../../../button/button.module';
import { ScrollViewModule } from '../../../../../scroll-view/scroll-view.module';
import { SelectBoxModule } from '../../../../../select-box/select-box.module';
import { TextAreaModule } from '../../../../../text-area/text-area.module';
import { NoteFormModule } from '../../../note-form/note-form.module';
import { SelectObjectsTableModule } from '../../../select-objects-table/select-objects-table.module';
import { OccurrenceRegisterComponent } from './occurrence-register.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ScrollViewModule,
    SelectBoxModule,
    TextAreaModule,
    ButtonModule,
    ListModule,
    PaginationModule,
    ModalModule,
    ToolbarModule,
    TooltipModule,
    SelectObjectsTableModule,
    NoteFormModule,
    BlockModalDragModule,
  ],
  declarations: [OccurrenceRegisterComponent],
  exports: [OccurrenceRegisterComponent],
})
export class OccurrenceRegisterModule {}
